module.exports = __webpack_public_path__ + "media/images/G-05-7b94a2f12e4c7fffc0f13567c05f57ee.svg";